import { IProject } from '@core/state/entities/project/project.entity';
import { createSelector } from '@ngrx/store';
import { selectEntitySlice } from '@core/state/entities/entity.selectors';
import { entityKey } from '@core/state/entities/entity-name-map';
import { IProjectsListingVM } from '@core/state/entities/project/project-summary.viewmodel';
import { throwErrorExp } from '@core/actions/util';

export const toProjectListingVm = (project: IProject): IProjectsListingVM => {
  const {
    screeningMachineLearningEnabled,
    contactEmail,
    inclusionCriteria,
    exclusionCriteria,
    details,
    secureDetails,
    ...noReg
  } = project;
  return {
    ...noReg,
  };
};
export const selectProjectListings = createSelector(
  selectEntitySlice(entityKey.projects),
  (projectsSlice): IProjectsListingVM[] =>
    projectsSlice.allIds
      .map((id) => projectsSlice.byId[id])
      .map((project) => toProjectListingVm(project))
);
export const filterMyProjectsVms = (
  allProjectsListings: IProjectsListingVM[]
): IProjectsListingVM[] =>
  allProjectsListings.filter(
    (p) => p.isMember && p.isDisabled !== true
  );
export const filterOtherProjectsVms = (
  allProjectsListings: IProjectsListingVM[]
): IProjectsListingVM[] =>
  allProjectsListings.filter(
    (p) =>
      p.isPublic &&
      !p.isMember &&
      p.isDisabled !== true &&
      !p.hasPendingInvitation &&
      !p.hasPendingJoinRequest
  );
export const filterPendingProjectVms = (
  allProjectListings: IProjectsListingVM[]
): IProjectsListingVM[] =>
  allProjectListings.filter(
    (p) => p.hasPendingJoinRequest || p.hasPendingInvitation
  );
export const filterInvitedProjectsVms = (
  allProjectsListings: IProjectsListingVM[]
): IProjectsListingVM[] =>
  allProjectsListings.filter((p) => p.hasPendingInvitation);
export const filterJoinRequestedProjectsVms = (
  allProjectsListings: IProjectsListingVM[]
): IProjectsListingVM[] =>
  allProjectsListings.filter((p) => p.hasPendingJoinRequest);
export const filterAdminProjectsVms = (
  allProjectsListings: IProjectsListingVM[]
): IProjectsListingVM[] => allProjectsListings.filter((p) => p.isAdmin && p.isDisabled !== true);
export const filterNonAdminProjectsVms = (
  allProjectsListings: IProjectsListingVM[]
): IProjectsListingVM[] =>
  allProjectsListings.filter((p) => !p.isAdmin && p.isMember && p.isDisabled !== true);
